<template>
  <div id="app">
    <head-Back title="防骗指南"></head-Back>
    <div class="arreement">
      <p class="title_small">一、本应用声明</p>
      <p
        class="desc"
      >本应用是一款私密聊天软件，与QQ、微信一样，主要为用户提供聊天交友的相关功能。作为独立的聊天软件，本应只属于好运吧平台，
      若遇到冒充本应用客服或假借本应用名义联系您的情况，请先联系本应用的官方客服（聊天号10001）、定制客服（聊天号：10000）投诉与建议客服（聊天号10002）确认。</p>
      <p class="desc" >网络骗术层出不穷，请警惕任何利用聊天工具进行的欺诈行为，如娱乐平台充值、贷款缴纳手续费、兼职刷单、套现返现、网络彩票等。若遇到此类情况，建议第一时间保存好相关资料，向相关平台或机构举报，并报警求助。
      <p class="title_small">二、案例介绍</p>
      <p class="title_small">1、以兼职刷单名义诈骗</p>
      <p class="desc">此类诈骗人员通常谎称自己是淘宝或京东客服，以高额佣金为诱饵吸引受害者先行垫付 本金，任务完成后会与佣金一同返还。
      </p><p class="desc">诈骗步骤：
      </p><p class="desc">第一步：将购买链接发送给受害者，要求受害者下单后“千万不要立即付款”。
     </p><p class="desc"> 第二步：诈骗人员提供自己的银行账号或收款二维码，要求受害者用这种方式完成付款。前几次付款后，诈骗人员一般会返还受害者垫付的本金和佣金，获得受害者的信任。
     </p><p class="desc"> 第三步：受害者完成几单任务要求返现时，诈骗人员会以连单或任务未完成为由，要求受害者连续支付大量订单，否则之前支付的钱将不会返还，实现多次诈骗。
      郑重提醒大家：网络上的兼职基本都不可信，特别是要求交纳培训费、押金、手续费、中介费、垫付本金之类的，绝对不要相信。
      </p><p class="title_small">2、以网络贷款名义诈骗
      </p><p class="desc"> 此类诈骗人员会以无抵押、无担保、低利息、快速简单办理各种贷款为诱饵，引诱受害者入局。
      诈骗步骤：
      </p><p class="desc">第一步：让注册某贷款APP或网站。诈骗人员一般会先让受害者注册“某某贷”“某某金融”的贷款APP或网站，填写相关的基本信息，并让其申请贷款额度。
      </p><p class="desc">第二步：要求缴纳手续费。申请贷款后，诈骗人员会编造各种理由让受害者缴纳各种费用。比如，想申请通过必须先缴纳平台费，银行账户被冻结需缴纳解冻费，提现前需要先缴纳保险费，信用不良需缴纳保证金等等。
      </p><p class="desc">第三步：让等待提现。当受害者将各种费用打入诈骗人员提供的账户后，一般会被告知几个工作日后才能对借款提现。而在这个时候，诈骗人员却在转移钱款、注销账号，做着骗局的收尾工作。
      郑重提醒大家：需要申请贷款时，到银行和正规贷款机构申办是唯一正确的选择，切勿轻信各类电话、短信、聊天软件上发送的贷款信息。最重要的是，正规贷款机构在贷款发放前不会收取审核费、保证金等各种费用。
      </p><p class="title_small">3、以网络彩票名义诈骗
      </p><p class="desc">此类诈骗人员会以网络彩票的名义，承诺“带你赚钱”“输了包赔”“回本”等吸引受害者，实则其实是在赌博。
      诈骗步骤：
      </p><p class="desc">第一步：宣传散布虚假消息。以美女交友、高回报投资吸引关注，承诺“带你赚钱”“输了包赔”“回本”。
      </p><p class="desc">第二步：取得信任引诱充值。私底下安排诈骗人员对受害者透露平台内幕与漏洞操作，从而给与受害者稳赚不亏的心理错觉，以最开始的甜头让人放松警惕。
     </p><p class="desc"> 第三步：充值容易提现难。平台会给受害人制造能提现希望的假象，在操作过程中的某个细节进行卡位，要求受害人缴纳保证金、解冻费等再行充值的手法。有时还会常常出现页面错误，或者多次提取无法成功，通过各种话术逐步榨干受害人钱包。
      郑重提醒大家：目前在我国，已明令禁止互联网销售彩票，网络彩票不是诈骗就是赌博！大家千万不要在网上平台或手机APP上购买彩票。
      <p><p class="title_small">4、以解除游戏防沉迷名义诈骗
      </p><p class="desc"> 此类诈骗人员会以破解防沉迷、解除健康系统来吸引未成年游戏玩家，诱骗受害者钱财，或骗取受害者的游戏账号。
      诈骗步骤：
      </p><p class="desc"> 第一步：在各类贴吧、论坛散布可解除游戏防沉迷的信息。“可以，我一同学就帮我解了”、“之前也被骗过，后面找到一个大佬给解了”这些以假乱真的信息让曾被骗的人都十分迷惑，进而继续被骗。
      </p><p class="desc"> 第二步：让受害者付款。诈骗人员会要求受害者先支付几十到几百不等的服务费，若受害者怀疑，诈骗人员一般会改变策略，答应先解后付，先索要数额较小的电话费、短信费，然后一步步进行套路。
      </p><p class="desc"> 第三步：在收到受害者的付款之后，诈骗人员就会消失不见。在这期间，为了打消受害者顾虑，拖延时间，诈骗分子还可能伪造官方邮件。
      </p><p class="desc"> 郑重提醒大家：网络游戏的健康系统都接入了公安实名校验，所有玩家的实名认证信息都会与公安权威数据进行对比校验，校验为未成年的账号，将纳入防沉迷健康系统，是无法粗暴破解的。网上声称可以花钱解除防沉迷的，基本都是骗子。
      <p><p class="title_small">5、以裸聊为诱饵进行勒索诈骗
      <p><p class="desc">此类诈骗人员会利用受害者的“猎艳”心理，引诱其进行裸聊，随后通过录制的裸聊视频对受害者进行勒索。
      <p><p class="desc">诈骗步骤：
      <p><p class="desc">第一步：诈骗分子把自己包装成“开放、热情、性感”的美女形象，通过社交软件主动添加好友，在取得受害者一定信任后，提出视频裸聊的要求，在“裸聊”过程中录下受害者的不雅视频。
      <p><p class="desc">第二步：诈骗分子在聊天过程中诱导受害者安装特定APP或点击不明链接、扫描二维码，其目的主要是在受害者手机中植入木马软件，窃取个人通讯信息。（部分诈骗分子会省略次步骤）
      <p><p class="desc">第三步：诈骗分子将录制的不雅视频和窃取到的通讯录信息发送给受害者，威胁受害者转账汇款。
      <p><p class="desc">郑重提醒大家：色字头上一把刀，天下没有免费的午餐，何况是主动送上来的。在互联网上一定要保护好个人隐私，不要轻易在网上撩骚，不要将自己的私密照片、视频发送给陌生网友，也不要安装来历不明的软件。
      <p><p class="desc">（案例将不定期更新，再次提醒大家提高警惕，谨防上当受骗）</p>
    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back";

export default {
  metaInfo: {
    title: "防骗指南"
  },
  name: "app",
  data() {
    return {
      msg: "防骗指南"
    };
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
#app {
  width: 750px;
  height: 1334px;
}

.arreement {
  padding: 32px 58px 80px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 48, 48, 1);
  line-height: 40px;
}

.arreement h3 {
  width: 610px;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: rgba(48, 48, 48, 1);
  line-height: 50px;
}
.arreement p {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 48, 48, 1);
  line-height: 40px;
  text-align: left;
  /* text-indent: 40px; */
}
.arreement .arreement .title {
  text-align: left;
  padding-bottom: 30px;
  font-weight: bold;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: rgba(48, 48, 48, 1);
  line-height: 44px;
}
.arreement .title_small {
  padding-top: 20px;
  line-height: 0px;
}

.arreement span {
  text-align: left;
}

.arreement .bold {
  font-weight: bold;
}
.arreement .text_line {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/clac/cheat.vue